import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Sparkles } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
const curriculumData = [{
  title: 'Base técnica profesional',
  items: [{
    name: 'Anatomía de las uñas',
    desc: 'estructura de la uña para trabajar con fundamento técnico'
  }, {
    name: 'Microbiología básica',
    desc: 'reconocer enfermedades, microorganismos, resolver accidentes'
  }, {
    name: 'Bioseguridad',
    desc: 'esterilización química, descontaminación, herramientas y productos seguros'
  }, {
    name: 'Preparación de lámina ungueal',
    desc: 'técnica profesional para máxima adherencia y durabilidad'
  }, {
    name: 'Manicuría básica/universal',
    desc: 'dominio de la técnica clásica como base fundamental'
  }]
}, {
  title: 'Herramientas y aplicación',
  items: [{
    name: 'Manicuría combinada con torno/drill',
    desc: 'técnica avanzada combinando herramientas manuales y eléctricas'
  }, {
    name: 'Esmaltado Semipermanente Perfecto',
    desc: 'aplicación impecable para un acabado duradero'
  }, {
    name: 'Remoción segura',
    desc: 'sin dañar la lámina natural'
  }, {
    name: 'Hard Gel & Capping',
    desc: 'nivelación, balance y refuerzo'
  }, {
    name: 'Uso de torno/drill + fresas',
    desc: 'manejo profesional para acabado de estudio'
  }, {
    name: 'Pinceles y productos',
    desc: 'qué usar para no tener gastos innecesarios'
  }]
}, {
  title: 'Sistemas y estructuras',
  items: [{
    name: 'Corte y colocación de molde',
    desc: 'correcta colocación con acrílico, gel, polygel, etc.'
  }, {
    name: 'Técnicas híbridas',
    desc: 'baby glitter, canales de adherencia, administración de productos'
  }, {
    name: 'Puntas de salón',
    desc: 'Square, Coffin y Stiletto (las más demandadas)'
  }, {
    name: 'Encapsulado Perfecto',
    desc: 'técnica profesional con acabado impecable'
  }, {
    name: 'Técnica de reversa',
    desc: 'método avanzado para diseños con profundidad'
  }, {
    name: 'Técnicas de limado',
    desc: 'limado profesional para acabado fino y uniforme'
  }, {
    name: 'Esmaltado sobre esculpidas',
    desc: 'semipermanente sobre uñas esculpidas + remoción'
  }]
}, {
  title: 'Diseño y tendencias',
  items: [{
    name: 'Técnica Baby Boomer',
    desc: 'degradé suave y profesional, uno de los más pedidos'
  }, {
    name: 'Nail Art de cero a experta',
    desc: 'dibujo a mano alzada, cartoons y Flowers 3D'
  }, {
    name: 'Diseños muy pedidos',
    desc: 'baby color, baby glitter, tendencias actuales'
  }]
}];
const bonusData = {
  title: '✦ BONUS — Nivel Especial ✦',
  subtitle: 'Ideal para trabajar también desde casa',
  items: [{
    name: 'Técnica Press On',
    desc: 'sets desmontables, reutilizables y en tendencia; toma de medidas a distancia'
  }, {
    name: 'Soft Gel / Dipping',
    desc: 'extensiones de alta durabilidad y acabado profesional'
  }]
};
export function Curriculum() {
  const [openBlock, setOpenBlock] = useState<number | null>(0);
  const toggleBlock = (index: number) => {
    setOpenBlock(openBlock === index ? null : index);
  };
  return <SectionWrapper bg="white" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-warm-dark mb-4" data-id="element-17">
          ¿Qué vas a aprender dentro del programa?
        </h2>
        <p className="text-center text-warm-muted mb-12 font-medium" data-id="element-18">
          Vas a trabajar técnica real, no "tips sueltos":
        </p>

        <div className="space-y-4" data-id="element-19">
          {curriculumData.map((block, idx) => <div key={idx} className="border border-blush rounded-2xl overflow-hidden bg-cream shadow-sm" data-id="element-20">
              <button onClick={() => toggleBlock(idx)} className="w-full flex items-center justify-between p-5 md:p-6 bg-white hover:bg-blush/50 transition-colors text-left" data-id="element-21">
                <div className="flex items-center gap-4" data-id="element-22">
                  <span className="bg-rose text-white text-sm font-bold w-8 h-8 rounded-full flex items-center justify-center shrink-0" data-id="element-23">
                    {idx + 1}
                  </span>
                  <h3 className="font-serif font-bold text-lg md:text-xl text-warm-dark" data-id="element-24">
                    Bloque {idx + 1}: {block.title}
                  </h3>
                </div>
                <ChevronDown className={`w-5 h-5 text-rose transition-transform duration-300 ${openBlock === idx ? 'rotate-180' : ''}`} data-id="element-25" />
              </button>

              <AnimatePresence data-id="element-26">
                {openBlock === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-27">
                    <div className="p-5 md:p-6 border-t border-blush" data-id="element-28">
                      <ul className="space-y-4" data-id="element-29">
                        {block.items.map((item, itemIdx) => <li key={itemIdx} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-2" data-id="element-30">
                            <span className="font-bold text-warm-dark shrink-0" data-id="element-31">
                              • {item.name}
                            </span>
                            <span className="hidden sm:inline text-warm-muted" data-id="element-32">
                              —
                            </span>
                            <span className="text-warm-muted text-sm md:text-base" data-id="element-33">
                              {item.desc}
                            </span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}

          {/* Bonus Block */}
          <div className="mt-8 border-2 border-gold rounded-2xl overflow-hidden bg-gradient-to-br from-white to-[#FFFDF9] shadow-soft relative" data-id="element-34">
            <div className="absolute top-0 right-0 p-4 opacity-20 pointer-events-none" data-id="element-35">
              <Sparkles className="w-24 h-24 text-gold" data-id="element-36" />
            </div>
            <div className="p-6 md:p-8 relative z-10" data-id="element-37">
              <div className="text-center mb-6" data-id="element-38">
                <h3 className="font-serif font-bold text-2xl text-gold mb-2" data-id="element-39">
                  {bonusData.title}
                </h3>
                <p className="text-warm-muted italic text-sm" data-id="element-40">
                  {bonusData.subtitle}
                </p>
              </div>

              <ul className="space-y-5" data-id="element-41">
                {bonusData.items.map((item, idx) => <li key={idx} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-2 bg-white/60 p-4 rounded-xl border border-gold/20" data-id="element-42">
                    <span className="font-bold text-warm-dark shrink-0" data-id="element-43">
                      ✦ {item.name}
                    </span>
                    <span className="hidden sm:inline text-warm-muted" data-id="element-44">—</span>
                    <span className="text-warm-muted text-sm md:text-base" data-id="element-45">
                      {item.desc}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}